/**
 * Creative Gradient Blob
 *
 * Desktop: A large blurred gradient circle follows the cursor within gradient blocks.
 * Mobile/Tablet: Falls back to a static animated gradient.
 */
export default function initGradientBlob({
    blockSelector,
    blobSelector,
    staticClass,
}) {
    const gradientBlocks = document.querySelectorAll(blockSelector);
    if (!gradientBlocks.length) return;

    const mql = window.matchMedia('(min-width: 841px)');

    function onMouseMove(e) {
        gradientBlocks.forEach((block) => {
            const rect = block.getBoundingClientRect();

            if (
                e.clientX < rect.left ||
                e.clientX > rect.right ||
                e.clientY < rect.top ||
                e.clientY > rect.bottom
            ) {
                return;
            }

            const blob = block.querySelector(blobSelector);
            if (!blob) return;

            blob.style.left = `${e.clientX - rect.left}px`;
            blob.style.top = `${e.clientY - rect.top}px`;
        });
    }

    function handleMediaChange(e) {
        gradientBlocks.forEach((block) => {
            const blob = block.querySelector(blobSelector);
            if (!blob) return;

            if (e.matches) {
                blob.classList.remove(staticClass);
            } else {
                blob.classList.add(staticClass);
                blob.style.left = '';
                blob.style.top = '';
            }
        });

        if (e.matches) {
            document.addEventListener('mousemove', onMouseMove);
        } else {
            document.removeEventListener('mousemove', onMouseMove);
        }
    }

    mql.addEventListener('change', handleMediaChange);
    handleMediaChange(mql);
}
